import moment from 'moment'

export default {
  getMessage(field, args) {
    return field
  },
  validate(value, args) {
    let _value = moment(value, 'DD/MM/YYYY', true)
    let _valueMinus5 = moment().subtract(5, 'years')
    return !_value.isAfter(_valueMinus5)
  }
}
